import { getDay } from 'date-fns/esm'
import { dateUtils } from '@/utils'
import { type RecurrenceSettingsState } from '../../../../types'

export function computeRecurrencePeriod(
  state: RecurrenceSettingsState,
  recurrenceType: uui.domain.ui.forms.ExtendedRecurrencePeriodType,
): uui.domain.ui.forms.RecurrencePeriod {
  const { referenceDate } = state

  switch (recurrenceType) {
    case 'NO_REPEAT':
      return {
        recurrenceType,
        date: dateUtils.convertToYYYYMMDD(referenceDate),
        period: 1,
      }

    case 'DAILY':
      return {
        recurrenceType,
        period: 1,
        date: dateUtils.convertToYYYYMMDD(referenceDate),
      }

    case 'WEEKLY':
      return {
        date: dateUtils.convertToYYYYMMDD(referenceDate),
        recurrenceType,
        period: 1,
        weekday: getDay(referenceDate) as uui.domain.client.rm.WeekDay,
      }

    case 'MONTHLY':
    case 'ANNUALLY': {
      return {
        recurrenceType,
        period: 1,
        date: dateUtils.convertToYYYYMMDD(referenceDate),
      }
    }
  }
}
